/**
 * Single product gallery with vertical thumbnails using Swiper.
 */
export function initSingleProduct() {
  initSingleProductGallery();
  initStickyCta();
}

function initSingleProductGallery() {
  var galleries = document.querySelectorAll('.serawai-gallery');
  if (!galleries.length) {
    return;
  }

  galleries.forEach(function (gallery) {
    var mainEl = gallery.querySelector('.serawai-main-swiper');
    var thumbsEl = gallery.querySelector('.serawai-thumbs-swiper');

    if (!mainEl || !thumbsEl) {
      return;
    }

    var thumbsSwiper = new Swiper(thumbsEl, {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      slideToClickedSlide: true,
      breakpoints: {
        0: {
          direction: 'horizontal',
          slidesPerView: 4,
        },
        992: {
          direction: 'vertical',
          slidesPerView: 'auto',
        },
      },
    });

    new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: mainEl.querySelector('.swiper-button-next'),
        prevEl: mainEl.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: mainEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  });
}

function initStickyCta() {
  var sidebar = document.querySelector('.serawai-product-sidebar');
  var cta = document.querySelector('.serawai-product-cta');
  if (!sidebar || !cta) {
    return;
  }

  var updateSticky = function () {
    if (window.innerWidth < 992) {
      cta.style.position = '';
      cta.style.top = '';
      return;
    }

    var sidebarRect = sidebar.getBoundingClientRect();
    var ctaHeight = cta.offsetHeight;
    var viewportHeight = window.innerHeight;
    var topSpacing = 24;

    if (ctaHeight + topSpacing * 2 < viewportHeight) {
      cta.style.position = 'sticky';
      cta.style.top = topSpacing + 'px';
    } else {
      cta.style.position = '';
      cta.style.top = '';
    }
  };

  updateSticky();
  window.addEventListener('resize', updateSticky);
}
